var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallTrophyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1325_16248)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5074 57.4405C79.0652 52.1694 80.4997 46.2522 80.4997 40C80.4997 17.9086 62.5912 0 40.4997 0C32.2155 0 24.5193 2.51843 18.1353 6.83137C17.9606 6.94945 17.7878 7.06887 17.6171 7.18962C7.26919 14.4197 0.499908 26.4188 0.499908 40C0.499908 56.3572 10.3181 70.4212 24.3827 76.6202L55.9634 76.9012C64.8199 73.1853 72.0563 66.3741 76.3198 57.8209C76.383 57.6948 76.4455 57.568 76.5074 57.4405Z",
    fill: "#06C167"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1772 64.2505C32.0858 64.2505 14.1772 46.3419 14.1772 24.2505C14.1772 17.9975 15.6132 12.0805 18.1716 6.80908C7.51167 13.9942 0.499908 26.1777 0.499908 40C0.499908 56.3572 10.3181 70.4212 24.3827 76.6202L55.9634 76.9012C64.9509 73.1303 72.2701 66.1719 76.5071 57.4401C70.1297 61.7396 62.447 64.2505 54.1772 64.2505Z",
    fill: "#0E8345"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2695 73.4873H37.967L32.9515 13.1831L21.8243 13.6157L33.2695 73.4873Z",
    fill: "#FA870A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6454 73.4873H40.343V27.6129L28.8978 35.3522L35.6454 73.4873Z",
    fill: "#E7A52E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4166 73.4873H42.7191L47.7346 13.1831L58.8618 13.6157L47.4166 73.4873Z",
    fill: "#E7A52E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0406 73.4873H40.343V27.6129L51.7882 35.3522L45.0406 73.4873Z",
    fill: "#ECC32E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.343 0.127563L46.0655 11.7227L58.8617 13.5822L49.6023 22.6077L49.655 22.9147L43.8798 26.5149L32.9908 22.094L28.8978 15.6698L29.3708 12.4855L34.6205 11.7227L40.343 0.127563Z",
    fill: "#F9EF63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6015 23.3372C37.74 23.3372 31.1482 18.7131 29.3708 12.4855L21.8243 13.5821L31.0836 22.6077L28.8977 35.352L40.343 29.335L51.7882 35.3521L49.655 22.9148C48.3571 23.1903 46.9997 23.3372 45.6015 23.3372Z",
    fill: "#F1D333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.721 75.749L53.3526 64.4727H37.0569V75.749H55.721Z",
    fill: "#736E6E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4999 80C45.9821 80 51.2059 78.8959 55.9628 76.8996L55.6676 75.4941H46.5424C40.7278 75.4941 36.3667 70.1743 37.5073 64.4727H26.8132L24.3837 76.6176C29.3145 78.7909 34.7656 80 40.4999 80Z",
    fill: "#595454"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7316 76.706H42.9022L41.7896 76.3108L40.343 76.706H38.6393L35.6244 76.2332L32.9427 76.706H31.6174V69.2909H36.8246L39.594 70.111L42.5212 69.2909H44.2249L45.2348 69.6794L46.7841 69.2909H48.7316V76.706Z",
    fill: "#F1D333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9427 76.706H38.6393L42.5212 69.2909H36.8246L32.9427 76.706Z",
    fill: "#F9EF63"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.343 76.706H42.9022L46.7841 69.2909H44.2249L40.343 76.706Z",
    fill: "#F9EF63"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6451 10.6605C71.6257 14.0836 74.3014 16.7593 77.7244 17.7397C74.3013 18.7203 71.6255 21.3961 70.6451 24.819C69.6646 21.3959 66.9888 18.7201 63.5659 17.7397C66.989 16.7593 69.6647 14.0836 70.6451 10.6605Z",
    fill: "#F9EF63"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3192 4.05884C56.8125 5.78135 58.159 7.12786 59.8815 7.62119C58.159 8.11452 56.8125 9.46103 56.3192 11.1835C55.8259 9.46103 54.4793 8.11452 52.7568 7.62119C54.4793 7.12786 55.8257 5.78135 56.3192 4.05884Z",
    fill: "#F9EF63"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0768 0C67.7077 2.20282 69.4298 3.92486 71.6326 4.55576C69.4298 5.18667 67.7077 6.90871 67.0768 9.11153C66.4459 6.90871 64.7239 5.18667 62.5211 4.55576C64.7239 3.92486 66.4459 2.20282 67.0768 0Z",
    fill: "#F9EF63"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.515 48.8613C21.4245 52.0367 23.9066 54.5187 27.0819 55.4282C23.9065 56.3377 21.4245 58.8199 20.515 61.9951C19.6055 58.8198 17.1233 56.3377 13.9481 55.4282C17.1233 54.5187 19.6055 52.0365 20.515 48.8613Z",
    fill: "#F9EF63"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58241 44.7837C9.0806 46.523 10.4403 47.8827 12.1796 48.3809C10.4403 48.8791 9.0806 50.2387 8.58241 51.978C8.08421 50.2387 6.72452 48.8791 4.98523 48.3809C6.72452 47.8828 8.08421 46.5231 8.58241 44.7837Z",
    fill: "#F9EF63"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6631 37.5859C17.2483 39.6294 18.8456 41.2267 20.8891 41.812C18.8456 42.3972 17.2483 43.9946 16.6631 46.038C16.0778 43.9946 14.4805 42.3972 12.437 41.812C14.4803 41.2267 16.0776 39.6294 16.6631 37.5859Z",
    fill: "#F9EF63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1325_16248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.499908)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTrophyLogo);
export default __webpack_public_path__ + "static/media/small-trophy-logo.830eef0c8d8e858c3e6412a5234a64c2.svg";
export { ForwardRef as ReactComponent };